// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2MP4y","alert":"SettungsInbox_alert__5xwh1"};